module.exports = __webpack_public_path__ + "static/img/logo.24dd08b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.svg
// module id = zxL1
// module chunks = 2